// extracted by mini-css-extract-plugin
export default {"book_from_us":"NewUIBookWithUs_book_from_us__gtYlK","cards_flex":"NewUIBookWithUs_cards_flex__wTJwY","card":"NewUIBookWithUs_card__WJa-e"};